<template>
  <div class="accordion-item bg-white border border-gray-200 mb-2">
    <h2 class="accordion-header mb-0">
      <button @click="toggle" class="
        accordion-button
        relative
        flex
        items-start
        w-full
        py-4
        px-5
        text-base text-gray-800 text-left
        bg-white
        border-0
        rounded-none
        transition
        focus:outline-none
      " type="button" data-bs-toggle="collapse" data-bs-target="#collapseOne" aria-expanded="true"
              aria-controls="collapseOne"
      >
       <i :class="item.icon" class="mt-1 mr-2"></i> <slot name="header"></slot>
      </button>
    </h2>
    <div v-if="isOpen" class="accordion-collapse collapse" aria-labelledby="headingOne"
         data-bs-parent="#accordionExample"
    >
      <div class="accordion-body py-4 px-5">
        <slot name="content"></slot>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AccordionItem',

  props: {
    item: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      isOpen: false,
    }
  },

  methods: {
    toggle: function() {
      this.isOpen = !this.isOpen
    },
  },
}
</script>

<style scoped>

</style>